import { createAsyncThunk } from '@reduxjs/toolkit';
import { getParams } from '../common/get-params';

let drilldownControllerRef = null;
const getJobsCard = async (
  { timeFrame = {}, filters = {} },
  { extra: { atsHttp } }
) => {
  const params = getParams({ timeFrame, filters, compare: true });
  const hireCardResponse = atsHttp.post(`/reports/jobs/card`, params);
  return hireCardResponse;
};

const getOfferTableAndChart = async (
  { timeFrame = {}, group = {}, filters = {} },
  { extra: { atsHttp } }
) => {
  const params = getParams({ timeFrame, group, filters });
  const hireCardResponse = atsHttp.post(`/reports/jobs/chart_table`, params);
  return hireCardResponse;
};

const getOpenJobChart = async (
  { timeFrame = {}, group = {}, filters = {} },
  { extra: { atsHttp } }
) => {
  const params = getParams({ timeFrame, group, filters });
  const hireCardResponse = atsHttp.post(`/reports/jobs/chart_table`, params);
  return hireCardResponse;
};

const getJobsVisual = async (
  { timeFrame = {}, group = {}, filters = {} },
  { extra: { atsHttp } }
) => {
  const params = getParams({ timeFrame, group, filters });
  const offerResponse = atsHttp.post(`/reports/jobs/visual`, params);
  return offerResponse;
};

const getJobDrilldown = async (
  { timeFrame = {}, group = {}, filters = {}, drilldown = {}, customFilter },
  { extra: { atsHttp } }
) => {
  if (drilldownControllerRef) {
    drilldownControllerRef.abort();
  }

  // Create a new controller for this request
  const controller = new AbortController();
  drilldownControllerRef = controller;
  try {
    const params = getParams({
      timeFrame,
      group,
      filters,
      drilldown,
      customFilter,
      compare: false,
    });
    const response = await atsHttp.post(`/reports/jobs/drilldown`, params, {
      signal: controller.signal,
    });
    return response;
  } catch (error) {
    if (error.name === 'AbortError' || error.name === 'CanceledError') {
      throw error;
    }
    throw error;
  }
};

export const fetchJobsCard = createAsyncThunk(
  'ats-reports/jobs/card',
  getJobsCard
);

export const fetchJobTableAndChart = createAsyncThunk(
  'ats-reports/jobs/table-chart',
  getOfferTableAndChart
);

export const fetchOpenJobChart = createAsyncThunk(
  'ats-reports/jobs/open-job-chart',
  getOpenJobChart
);

export const fetchJobsByDepartmentVisual = createAsyncThunk(
  'ats-reports/jobs/department/visual',
  getJobsVisual
);

export const fetchJobByLocationVisual = createAsyncThunk(
  'ats-reports/jobs/location/visual',
  getJobsVisual
);

export const fetchJobDrilldown = createAsyncThunk(
  'ats-reports/jobs/drilldown',
  getJobDrilldown
);

// export const fetchOfferByRejectionReason = createAsyncThunk(
//   'ats-reports/offers/rejection/source',
//   getRejectionReason
// );
